/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerOnlinePaymentRequest as ModelsCustomerCustomerOnlinePaymentRequest } from '../../models/Models/Customer/customer-online-payment-request';
import { CustomerOnlinePaymentResponse as ModelsCustomerCustomerOnlinePaymentResponse } from '../../models/Models/Customer/customer-online-payment-response';

export interface V3CustomersMeOnlinePaymentsPost$Xml$Json$Params {
      body?: ModelsCustomerCustomerOnlinePaymentRequest
}

export function v3CustomersMeOnlinePaymentsPost$Xml$Json(http: HttpClient, rootUrl: string, params?: V3CustomersMeOnlinePaymentsPost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMeOnlinePaymentsPost$Xml$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentResponse>;
    })
  );
}

v3CustomersMeOnlinePaymentsPost$Xml$Json.PATH = '/v3/customers/me/online-payments';
